export default __webpack_public_path__ + "static/media/arrow-up-white.914d0a3a.svg";